<div class="container" [ngStyle]="{height: containerHeight}">
    <mat-dialog-title class="title-block">
        <h2>ADD SHOW(S)</h2>
        <app-close-x-icon (click)="onClose()"></app-close-x-icon>
    </mat-dialog-title>
    <mat-dialog-content class="content-block" [ngStyle]="{height: contentHeight}">

        <div class="show-input-form">
            <mat-form-field class="show-form-field">
                <mat-label>SHOW NAME</mat-label>
                <input class="show-input-field" matInput placeholder="Enter Show Name"
                    [(ngModel)]="newShowName">
            </mat-form-field>
        </div>

        <button class="add-another-show-btn" (click)="addShowToList()"><app-plus-icon [stroke]="'black'"></app-plus-icon> Add another show</button>

        <div class="shows-list" *ngIf="this.newShows.length > 0" [ngStyle]="{height: showListHeight}">
            <div *ngFor="let show of newShows">
                <span class="show-list-item"><app-delete-icon (click)="removeShowFromList(show)"></app-delete-icon> {{show.name}}</span>
            </div>
        </div>

    </mat-dialog-content>

    <mat-dialog-actions class="action-block">
        <button class="add-show-btn" mat-button (click)="addNewShow()"><span *ngIf="newShows.length < 2">ADD SHOW</span> <span *ngIf="newShows.length >= 2">ADD SHOWS</span></button>
        <button class="cancel-btn" mat-button (click)="onClose()">CANCEL</button>
    </mat-dialog-actions>
</div>